import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import 'vuetify/src/styles/main.sass';
import 'vuetify/src/stylus/app.styl';

Vue.use(Vuetify, {
  theme: {
    primary: '#085280',
    background: '#E0F1F0',
    secondary: '#0B79BF',
    accent: '#EAEEF7',
    error: '#FF5252',
    success: '#4CAF50',
    info: '#A0A0A0',
    warning: '#FFA94B',
    critical: '#EA4335'
  },
  customProperties: true,
  iconfont: 'mdi'
});
